import * as React from "react";
import { Datagrid, SelectInput, TextField, TextInput } from "react-admin";
import { ExcelExport } from "../../../../src/Helper/ExportExcel";
import { SourceVwUser } from "../../../../src/Constants/Source";
import { NffReportExclusionPnExcelName, NffReportExclusionPnHeader } from "./Costants/Excel";
import CreatedByField from "../../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { CustomDateField } from "../../../Components/CustomDateField";
import { DetailButton } from "../../../../src/Components/DetailButton";
import { SourceNffReportExclusionPn } from "./Source";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";
import { useState } from "react";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { ThyFleetTypes } from "../../../../src/Constants/Constant";

const NffReportExclusionPnList = props => {
  const dataProvider = useAppDataProvider();
  const [customerCodeList, setCustomerCodeList] = useState<any>([]);

  const GetCustomerCodeList = () => {
    dataProvider
      .getList("customers", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerName", order: "ASC" },
        filter: {},
      })
      .then(response => {
        // Create a map to deduplicate by customerCode
        const customerMap = new Map();

        response?.data?.forEach(item => {
          if (!customerMap.has(item.customerCode)) {
            customerMap.set(item.customerCode, {
              customerCode: item.customerCode,
              customerName: item.customerCode,
            });
          }
        });

        // Convert map to array and add THY-C at the beginning
        const customerCodes = Array.from(customerMap.values());
        setCustomerCodeList(customerCodes);
      })
      .catch(error => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    GetCustomerCodeList();
  }, []);

  const filters = [
    <TextInput label="Pn" source="pn__contains" alwaysOn />,
    <SelectInput
      source="customer__contains"
      optionValue="customerCode"
      optionText="customerName"
      fullWidth
      variant="outlined"
      choices={customerCodeList}
      label="Customer"
      alwaysOn
    />,
    <SelectInput
      source="fleetType__contains"
      optionValue="value"
      optionText="type"
      fullWidth
      variant="outlined"
      choices={ThyFleetTypes}
      label="Fleet Type"
      alwaysOn
    />,
  ];

  const ExportToExcel = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, "createdBy", SourceVwUser).then(createdBy => {
      const data = records.map(record => ({
        ...record,
        createdBy: `${record.createdBy} - ${createdBy[record.createdBy]?.name ?? ""}`,
      }));
      ExcelExport(
        NffReportExclusionPnHeader,
        data.map(v => [v.pn, v.customer, v.fleetType, v.createdBy, v.createdDate]),
        NffReportExclusionPnExcelName
      );
    });
  };

  return (
    <PoolList
      {...props}
      bulkActionButtons={true}
      exporter={ExportToExcel}
      title={"NFF Report Exclusion PN List"}
      filters={filters}
    >
      <Datagrid>
        <DetailButton label="Actions" resource={SourceNffReportExclusionPn} {...props} />
        <TextField source="pn" label={"PN"} />
        <TextField source="customer" label={"Customer"} />
        <TextField source="fleetType" label={"Fleet Type"} />
        <CreatedByField source="createdBy" link={false} />
        <CustomDateField source="createdDate" />
        <CreatedByField source="updatedBy" link={false} />
        <CustomDateField source="updatedDate" />
      </Datagrid>
    </PoolList>
  );
};

export default NffReportExclusionPnList;
